import "./TrashInfo.scss";

const TrashInfo = () => {
  return (
    <div className="trash-info">
      <div className="stats">
        <div className="info">
          <h1>100%</h1>
          <h3>de nos produits ouate sont certifiés Ecolabel</h3>
        </div>
        <div className="info">
          <h1>96%</h1>
          <h3>de notre chimie est fabriquée en France</h3>
        </div>
      </div>
      <div className="trash">
        <div>
          <img src="/images/commitment/poubelle.png" alt="poubelle" />
        </div>
        <div>
          <div>
            <h3>Nos sacs poubelle</h3>
            <p>
              Notre gamme de produits historique, les sacs poubelle, a également
              su évoluer pour s'adapter à la demande. Aujourd'hui, 100% de nos
              sacs sont fabriqués à partir de polyéthylène recyclé à partir de
              film agricole, film bâtiment et chutes de production. A
              l'incinération, celui-ci ne dégage pas de vapeurs toxiques.
              <br />
              <br />
              Tous nos sacs sont fabriqués conformément aux normes NF EN 13592
              et NF 082 et peuvent vivre plusieurs cycles de recyclage.
              <br />
              <br />
              En plus d'être respectueux de l'environnement, les sacs en
              polyéthylène présentent de nombreux avantages. Ils sont aussi bien
              adaptés à l'usage en intérieur qu'en extérieur grâce à leur
              résistance à l'humidité et aux UV. Ainsi, ils ne craignent ni la
              corrosion ni l'oxydation.
            </p>
          </div>
          <div className="button-info">
            <button>Nos produits Ecolabel</button>
            <button id="product">Nos produits recyclés</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrashInfo;
